// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3SIyW","content":"ManualTimeModal_content__jafxL"};